<template>
    <div class="group block">
        <div class="post p-4 rounded-md relative overflow-hidden">
            <div class="block lg:hidden" v-if="memberAmount > 1">
                <Icon
                    v-if="position === 'lastSlide' || position === 'middleSlide'"
                    type="TailLeft"
                    viewBox="0 0 29 21"
                    width="25"
                    height="25"
                    class="z-10 text-white absolute left-8 fill-none stroke-current transform"
                />
                <Icon
                    v-if="position === 'firstSlide' || position === 'middleSlide'"
                    type="TailRight"
                    viewBox="0 0 29 21"
                    width="25"
                    height="25"
                    class="z-10 text-white absolute right-8 fill-none stroke-current transform"
                />
            </div>
            <div
                :style="backgroundStyle"
                class="absolute top-0 left-0 w-full h-full group-hover:scale-110 transition-all ease-in-out duration-500 bg-cover bg-no-repeat bg-center"
            ></div>
            <div class="overlay-bottom-dark absolute top-0 bottom-0 left-0 right-0 w-full h-full z-[5]"></div>
            <div class="absolute top-0 left-0 w-full h-full p-4 flex items-end text-white z-[10] group-hover:bg-blue-dark/10">
                <div>
                    <strong class="mt-2 block">
                        {{ displayName }}
                    </strong>
                    <div
                        v-if="displayName"
                        :class="[activeHover ? 'flex' : 'hidden']"
                        class="flex-row gap-2 group-hover:gap-3 transition-all ease-in-out duration-500 items-center mt-2"
                    >
                        <span>
                            {{ $translate(member.position) }}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    props: [
        'member',
        'height',
        'active',
        'position', // image position, not job position of member
        'memberAmount'
    ],

    data: () => ({
        postHeight: null,
        postImage: null,
        activeHover: null,
        template_image_male: 'hkcm/images/team/team_m.svg',
        template_image_female: 'hkcm/images/team/team_w.svg'
    }),

    computed: {
        // Store the results once
        displayName() {
            return this.getMemberDisplayName();
        },

        backgroundStyle() {
            const imageUrl = this.member.portrait ? `url(${this.member.portrait})` : `url(${this.$asset(this.getPlaceholderImage(), 'public')})`;
            return { backgroundImage: imageUrl };
        }
    },

    mounted() {
        this.postHeight = this.height;

        // set image height to width
        this.$nextTick(() => {
            if (this.$refs.image) {
                this.$refs.image.clientHeight > this.$refs.image.clientWidth
                    ? (this.$refs.image.style.height = this.$refs.image.clientWidth + 'px')
                    : (this.$refs.image.style.width = this.$refs.image.clientHeight + 'px');
            }
        });

        window.addEventListener('resize', () => {
            this.activeHover = window.innerWidth <= 1024;
        });

        if (window.innerWidth <= 1024) this.activeHover = true;
    },

    methods: {
        getMemberDisplayName() {
            const { nickname, title, first_name, last_name, external } = this.member;

            const full_name =
                this.$translate(title) && last_name
                    ? `${this.$translate(title)} ${first_name ? first_name + ' ' : ''}${last_name}`
                    : first_name && last_name
                      ? `${first_name} ${last_name}`
                      : '';

            return this.$translate(nickname) || (full_name ? full_name + (external ? ' ' + this.$translate('(Ext.)') : '') : '');
        },

        getPlaceholderImage() {
            return this.member.gender === 'm' ? this.template_image_male : this.template_image_female;
        }
    },

    watch: {
        active(val) {
            this.activeHover = val;
        }
    }
};
</script>

<style scoped>
/* TODO: JL: kurze Erklärung scoped (warum v-bind?) */
.post {
    height: v-bind(postHeight);
}
</style>
